<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :label="attribute.mandatory ? ($attrs.label + ' *') : $attrs.label"
    :rules="rules"
    inputmode="numeric"
    pattern="[0-9]*"
  ></v-text-field>
</template>

<script>
export default {
  name: 'NumericAttribute',
  props: {
    attribute: {
      type: Object,
      required: true
    }
  },
  computed: {
    rules () {
      const list = []
      list.push((v) => (!v || /^[0-9]{1,9}$/.test(v)) || 'Du måste ange ett heltal')
      if (this.attribute.mandatory) {
        list.push((v) => !!v || `${this.$attrs.label} är obligatorisk`)
      }
      if (this.attribute.maxLength) {
        list.push((v) => (!v || v.length <= this.attribute.maxLength) || `Du kan ange max ${this.attribute.maxLength} tecken i detta fält`)
      }
      return list
    }
  }
}
</script>
